import React from 'react'
import PopupComponent from './PopupComponent'

function js() {
  return (
    <div>
        <PopupComponent/>      
    </div>
  )
}

export default js